import JournalsCell from './components/JournalsCell';
import TitleCell from './components/TitleCell';

export default [
  { field: 'name', title: 'Society', width: 15, render: TitleCell, sortable: true },
  { field: 'journals', title: 'Journals', width: 60, render: JournalsCell },
  { field: 'editors', title: 'Society Editors', width: 15, dataModifier: (list: any[] | null) => `${list?.length || 0}`, sortable: true },
];
